/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-400);
  --border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  --line-height: 1em;
  --gap: var(--nve-ref-space-xs);
  contain: none;
}

[internal-host] {
  padding: var(--padding);
  border-bottom: var(--border-bottom);
  color: var(--color);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  width: 100%;
}

::slotted(nve-tabs) {
  margin-block-end: calc(-1 * var(--padding));
}
